import { createStore } from 'vuex'

// 创建状态管理store
export default createStore({
  state: {
    // 设备类型 - 是否为移动端
    isMobile: false,

    // 用户信息
    user: {
      name: '',
      phone: '',
      email: ''
    },

    // 环志记录列表
    records: [],

    // 当前选中的记录
    currentRecord: null,

    // 加载状态
    loading: false,

    // 搜索关键词
    searchKeyword: '',

    // 筛选条件
    filters: {
      birdStatus: '',
      timeRange: [],
      locationRange: {}
    }
  },

  getters: {
    // 获取是否为移动端
    isMobile: state => state.isMobile,

    // 获取用户信息
    user: state => state.user,

    // 获取记录列表
    records: state => state.records,

    // 获取当前记录
    currentRecord: state => state.currentRecord,

    // 获取加载状态
    loading: state => state.loading,

    // 获取搜索关键词
    searchKeyword: state => state.searchKeyword,

    // 获取筛选条件
    filters: state => state.filters,

    // 获取过滤后的记录列表
    filteredRecords: state => {
      let filtered = state.records

      // 根据搜索关键词过滤
      if (state.searchKeyword) {
        const keyword = state.searchKeyword.toLowerCase()
        filtered = filtered.filter(record =>
          record.birdName.toLowerCase().includes(keyword) ||
          record.ringNumber.toLowerCase().includes(keyword) ||
          record.discovererName.toLowerCase().includes(keyword)
        )
      }

      // 根据鸟类状况过滤
      if (state.filters.birdStatus) {
        filtered = filtered.filter(record =>
          record.birdStatus === state.filters.birdStatus
        )
      }

      return filtered
    }
  },

  mutations: {
    // 设置设备类型
    setDeviceType(state, isMobile) {
      state.isMobile = isMobile
    },

    // 设置用户信息
    setUser(state, user) {
      state.user = { ...state.user, ...user }
    },

    // 设置记录列表
    setRecords(state, records) {
      state.records = records
    },

    // 添加记录
    addRecord(state, record) {
      state.records.unshift(record)
    },

    // 更新记录
    updateRecord(state, updatedRecord) {
      const index = state.records.findIndex(record => record.id === updatedRecord.id)
      if (index !== -1) {
        state.records.splice(index, 1, updatedRecord)
      }
    },

    // 删除记录
    removeRecord(state, recordId) {
      const index = state.records.findIndex(record => record.id === recordId)
      if (index !== -1) {
        state.records.splice(index, 1)
      }
    },

    // 设置当前记录
    setCurrentRecord(state, record) {
      state.currentRecord = record
    },

    // 设置加载状态
    setLoading(state, loading) {
      state.loading = loading
    },

    // 设置搜索关键词
    setSearchKeyword(state, keyword) {
      state.searchKeyword = keyword
    },

    // 设置筛选条件
    setFilters(state, filters) {
      state.filters = { ...state.filters, ...filters }
    },

    // 重置筛选条件
    resetFilters(state) {
      state.filters = {
        birdStatus: '',
        timeRange: [],
        locationRange: {}
      }
      state.searchKeyword = ''
    }
  },

  actions: {
    // 初始化用户信息
    initUser({ commit }, userInfo) {
      commit('setUser', userInfo)
    },

    // 初始化记录列表
    initRecords({ commit }, records) {
      commit('setRecords', records)
    },

    // 创建新记录
    createRecord({ commit }, record) {
      commit('addRecord', record)
    },

    // 编辑记录
    editRecord({ commit }, record) {
      commit('updateRecord', record)
    },

    // 删除记录
    deleteRecord({ commit }, recordId) {
      commit('removeRecord', recordId)
    },

    // 搜索记录
    searchRecords({ commit }, keyword) {
      commit('setSearchKeyword', keyword)
    },

    // 应用筛选条件
    applyFilters({ commit }, filters) {
      commit('setFilters', filters)
    },

    // 清除筛选条件
    clearFilters({ commit }) {
      commit('resetFilters')
    }
  }
})
